import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import BasicFormInput from '../form/BasicFormInput';
import BlitzAPI from '../../api/BlitzAPI';

class UserForm extends Component {
  constructor(props) {
    super(props);
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  onDeleteClick() {
    if (confirm('Delete this chatroom?')) {
      BlitzAPI.deleteUser(this.props.userId).then(
        () => browserHistory.push('/users'),
      );
    }
  }


  render() {
    const { handleSubmit, userId } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <Field
          type="text"
          name="name"
          placeholder="Name"
          component={BasicFormInput}
          controlId="chatroomName"
          label="Name"
        />
        <Field
          name="username"
          placeholder="Username"
          component={BasicFormInput}
          controlId="username"
          label="Username"
        />
        <Field
          name="email"
          type="email"
          placeholder="Email"
          component={BasicFormInput}
          controlId="email"
          label="Email"
        />
        {!userId && <Field
          name="password"
          type="password"
          component={BasicFormInput}
          controlId="password"
          label="Password"
        />}
        <Field
          name="image_url"
          type="url"
          placeholder="Image URL"
          component={BasicFormInput}
          controlId="image"
          label="Profile Picture URL"
        />
        <Field
          name="bio"
          type="text"
          placeholder="Biography"
          component={BasicFormInput}
          controlId="bio"
          label="Biography"
        />
        <Field
          type="checkbox"
          name="admin"
          placeholder="Admin"
          component={BasicFormInput}
          normalize={v => !!v}
          controlId="admin"
          label="Is Admin level user (Blitz)"
        />
        <Field
          type="checkbox"
          name="staff"
          placeholder="Staff level access"
          component={BasicFormInput}
          normalize={v => !!v}
          controlId="staff"
          label="Staff (Editor privileges)"
        />
        <Field
          type="checkbox"
          name="contributor"
          placeholder="Contributor"
          component={BasicFormInput}
          normalize={v => !!v}
          controlId="contibutor"
          label="Contributor"
        />

        <Field
          type="checkbox"
          name="banned"
          component={BasicFormInput}
          normalize={v => !!v}
          controlId="banned"
          label="BANNED -> Check if you want to chat ban the user"
        />
        <Button type="submit">Submit</Button>
        {/*
          userId ?
            <Button
              type="button"
              bsStyle="danger"
              className="pull-right"
              onClick={this.onDeleteClick}
            >Delete</Button> : null
        */}
      </form>
    );
  }
}

const selector = formValueSelector('user');
function mapStateToProps(state) {
  return {
    userId: selector(state, 'id'),
  };
}

UserForm = connect(
  mapStateToProps,
)(reduxForm({ form: 'user', enableReinitialize: true })(UserForm));

UserForm.propTypes = {
  handleSubmit: PropTypes.func,
  userId: PropTypes.number,
};

export default UserForm;



// WEBPACK FOOTER //
// ./src/cms/user/UserForm.js